import output from "_src/engine/output";

export default {
  logArguments(f) {
    function decorator(...a) {
      let argumentsString = "";
      for (const arg of [...arguments]) {
        try {
          argumentsString += JSON.stringify(arg) + ", ";
        } catch (e) {
          argumentsString += "Object, ";
        }
      }
      output.log(f.name + " called with " + argumentsString, output.BLACK, true);
      return f.apply(this, a);
    }

    decorator.funcName = f.name;

    return decorator;
  },

  applyDecoratorToWholeModule(decorator, module, exclusion = []) {
    for (const func in module) {
      if (typeof module[func] === "function" && !exclusion.includes(func)) {
        module[func] = decorator(module[func]);
      }
    }
  }
}

